import { render, staticRenderFns } from "./AlpineLayoutNoSidebar.vue?vue&type=template&id=59a9e4f0&scoped=true"
import script from "./AlpineLayoutNoSidebar.vue?vue&type=script&lang=ts"
export * from "./AlpineLayoutNoSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AlpineLayoutNoSidebar.vue?vue&type=style&index=0&id=59a9e4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a9e4f0",
  null
  
)

export default component.exports